import { useEffect, useState } from "react"
import useScreenSize from "./useScreenSize"

const useImage = images => {
  const { imageDesktop, imageMobile, bgDesktop, bgMobile, altText } =
    images || {}
  const [foregroundImg, setForegroundImg] = useState(null)
  const [backgroundImg, setBackgroundImg] = useState(null)
  const screen = useScreenSize()
  let imgData;

  if(imageDesktop?.file?.url) {
    imgData = {
      url: imageDesktop?.file?.url
    }
  }

  if(imageMobile?.file?.url) {
    imgData = {
      url: imageMobile?.file?.url
    }
  }

  useEffect(() => {
    if (screen?.isDesktop) {
      setBackgroundImg(bgDesktop)
      imageDesktop?.file?.url ? setForegroundImg(imgData) : setForegroundImg(imageDesktop)
    } 
    if(screen?.isMobile || screen?.isTablet) {
      setBackgroundImg(bgMobile || bgDesktop)
      imageMobile?.file?.url ? setForegroundImg(imgData) : setForegroundImg(imageMobile || imageDesktop)
    } 
  }, [screen])

  return {
    altText,
    foregroundImg,
    backgroundImg,
  }
}

export default useImage
